export var PageNames;
(function (PageNames) {
    PageNames["Question"] = "question";
    PageNames["Edit"] = "edit";
    PageNames["ThankYou"] = "thank_you";
    PageNames["Error"] = "error";
})(PageNames || (PageNames = {}));
//# sourceMappingURL=page-names.constants.js.map